import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import { 
  InputField,  
  required 
} from '../../form';

class BillingForm extends Component {

  onFormSubmit(values) {
    const { dispatch } = this.props;
    dispatch(setLoader('BillingForm'));
    dispatch(PublisherApi.actions.billingUpdate.post(values, (error, success) => {
      dispatch(removeLoader('BillingForm'));
      if (success) {
        dispatch({
          type: PublisherApi.events.billing.actionSuccess,
          syncing: false, 
          data: { data: success.data }
        });
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading } = this.props;

    return (    
      <form 
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))} 
      >
        <div>
          <Field 
            type='text' 
            name='billing[paypal_id]' 
            placeholder='Enter paymail email or phone'
            label='Paypal Email / Phone Number' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[name]' 
            placeholder='Your name'
            label='Name' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[company]' 
            placeholder='Company name'
            label='Company' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[address1]' 
            placeholder='Address line 1'
            label='Address Line 1' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[address2]' 
            placeholder='Address line 2'
            label='Address Line 2' 
            component={InputField}
          />

          <Field 
            type='text' 
            name='billing[city]' 
            placeholder='City'
            label='City' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[zipcode]' 
            placeholder='Zipcode'
            label='Zipcode' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[state]' 
            placeholder='State'
            label='State' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[country]' 
            placeholder='Country'
            label='Country' 
            component={InputField}
            validate={[required]}
          />

          <Field 
            type='text' 
            name='billing[phone]' 
            placeholder='Phone'
            label='Phone' 
            component={InputField}
          />
                  
        </div>
                  
        <div className='m-t-md text-right'>
          <Button 
            type='submit' 
            loading={isLoading} 
            bsStyle='primary'
          >
            Update
          </Button>
        </div>
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'BillingForm'
});


const mapStateToProps = (state, ownProps) => {
  const { loader } = state;
  const isLoading = loader.includes('BillingForm');
  const billing = ownProps.billing;  
  return { isLoading, initialValues: { billing } };
};

export default connect(mapStateToProps)(ResourceForm(BillingForm));
